import { produce } from 'immer'
import type { StateCreator } from 'zustand'

import { middleware } from '../middleware'
import type { Store } from '../types'

export type PurchaseFlowVariant = 'default' | 'my-move'

type PurchaseFlowState = {
  /**
   * Variant of the purchase flow to provide a way to adjust how the purchase flow behaves
   */
  variant: PurchaseFlowVariant
  /**
   * Active contract number, if available
   */
  contractNo?: number
}

type PurchaseFlowActions = {
  setVariant: (purchaseFlowVariant: PurchaseFlowVariant) => void
  setContractNo: (contractNo?: number) => void
}

/**
 * Information about order confirmation
 */
export type PurchaseFlowStore = {
  purchaseFlow: PurchaseFlowState & PurchaseFlowActions
}

// Good practice to keep it still, even while empty
export const initialState: PurchaseFlowState = {
  variant: 'default',
}

export const creator: StateCreator<Store, [['zustand/persist', unknown]], [], PurchaseFlowStore> = (
  set,
  get,
) => ({
  purchaseFlow: {
    ...initialState,
    setVariant: (purchaseFlowVariant) =>
      set(
        produce(get(), (state: Store) => {
          state.purchaseFlow.variant = purchaseFlowVariant
        }),
      ),
    setContractNo: (contractNo) =>
      set(
        produce(get(), (state: Store) => {
          state.purchaseFlow.contractNo = contractNo
        }),
      ),
  },
})

export const purchaseFlowSlice = middleware(creator, (_prevState, _set, _get, _store) => {})
